import PrintActions from '../../../actions/PrintActions';
import PosCartStore from '../../../stores/PosCartStore';
import Printing from '../../../utils/Printing';
import CartItem from './CartItem.react';
import CartSummary from './CartSummary.react';

class Cart extends React.Component {

    render() {
        let page                 = this.props.page;
        let guest                = this.props.guest;
        let cart                 = this.props.cart;
        let appliedLoyaltyPoints = this.props.appliedLoyaltyPoints;
        let appliedDiscounts     = this.props.appliedDiscounts;
        let allotment            = this.props.allotment;
        let cartSummary          = PosCartStore.getCartSummary();
        let remotePayInfo        = this.props.remotePayInfo;
        let payload              = {
            receiptId: guest.ShipmentId,
            subTotal: cartSummary.subTotal.flt,
            total: cartSummary.total.flt,
        }

        return (
            <div className='cart'>

                <div className='pos-search__content'>

                    <div className='pos-search__results'>

                        <div className='pos-search__header'>
                            <div
                                className='pos-search__header--print'
                            >
                                <i className='fa fa-print' onClick={() => { PrintActions.printPickListReceipt(guest); }} />
                                <i className='fa fa-receipt' style={{marginLeft: 10}} onClick={() => PrintActions.printPreCheckoutReceipt(payload)}/>
                            </div>                                                       
                            <div className='pos-search__header--qty' onClick={this.print}>
                                Qty
                            </div>
                            <div className='pos-search__header--desc'>
                                Description
                            </div>
                            <div className='pos-search__header--price'>
                                Price
                            </div>
                            <div className='pos-search__header--discount'>
                                Discount
                            </div>
                            <div className='pos-search__header--weight'>
                                Weight
                            </div>
                        </div>

                        { cart.map((item, i) => {
                            return (
                                <CartItem
                                    guest={guest}
                                    item={item}
                                    cart={cart}
                                    i={i}
                                    key={item.uuid} />
                            );
                        })}
                    </div>

                    <div className='pos-cart-print' id='PrintCart'>
                        <div className='pos-cart-print__header'>
                            <span className='pos-cart-print__title'>Item</span>
                            <span>qty</span>
                        </div>

                        { cart.map((item, i) => {

                            return (
                                <div className='pos-cart-print__row'>
                                    <span className='pos-cart-print__title'>
                                        {item.Product}
                                        <br />
                                        <span>{item.SerialNo}</span>
                                    </span>
                                    <span>
                                        {item.QtyAllocated}
                                    </span>
                                </div>
                            )
                        })}

                    </div>

                </div>

                <CartSummary
                    cart={cart}
                    guest={guest}
                    appliedLoyaltyPoints={appliedLoyaltyPoints}
                    allotment={allotment} 
                    remotePayInfo={remotePayInfo} />


            </div>
        );
    }
}

export default Cart;


// WEBPACK FOOTER //
// ./ui_src/app/components/pos/cart/Cart.react.jsx